export { CtaArrowAnimation as default } from "./CtaArrowAnimation";
